import { useNavigate } from "react-router-dom";

import AirlineSeatLegroomNormalIcon from "@mui/icons-material/AirlineSeatLegroomNormal";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { Box, Divider, MenuItem, MenuList } from "@mui/material";

import { AIRLINE_IMG, AIRLINE_NAME_MAP } from "@/constants/airline";
import { airlineBgColor } from "@/constants/config";
import { TOOLS_AIRLINE_FINDER } from "@/constants/eventName";
import { PROGRAM_IMG } from "@/constants/programs";
import { dispatchEvent } from "@/hooks/useEventEmitter";
import useThemeData from "@/hooks/useThemeData";

interface ToolsMenuProps {
  onClose: () => void;
}

const airlineTools = ["NH", "EK", "JL", "LH", "QR"];
const ToolsMenu = (props: ToolsMenuProps) => {
  const navigate = useNavigate();

  const theme = useThemeData();
  return (
    <MenuList>
      {/* <Divider /> */}
      <div className="font-bold text-center">First Class Explorers</div>
      {airlineTools.map((airline) => {
        const airlineName = AIRLINE_NAME_MAP[airline];
        return (
          <MenuItem
            key={airline}
            onClick={() => {
              props.onClose();
              dispatchEvent(TOOLS_AIRLINE_FINDER, {
                airlines: [airlineName],
              });
              navigate("/deals/flight");
            }}
          >
            <div className="flex items-center gap-1">
              <Box
                className="rounded-[3px] p-[4px] mr-[5px] text-[0px]"
                sx={{
                  backgroundColor: theme.isDarkMode ? airlineBgColor : "transparent",
                }}
              >
                <img className="w-[25px]" src={AIRLINE_IMG[airline]} alt="" />
              </Box>
              {airlineName} First Class Explorer
            </div>
          </MenuItem>
        );
      })}
      <Divider />
      <MenuItem
        onClick={() => {
          props.onClose();
          navigate("/live-seat-map");
        }}
      >
        <div className="flex items-center gap-1">
          <AirlineSeatLegroomNormalIcon
            color="primary"
            className="!text-[24px] w-[30px] mr-[13px] ml-[3px]"
          />
          Live Seat Map
        </div>
      </MenuItem>
      <Divider />
      <MenuItem
        onClick={() => {
          props.onClose();
          navigate("/guides");
        }}
      >
        <div className="flex items-center gap-1">
          <LocalOfferIcon color="primary" className="!text-[24px] w-[30px] mr-[13px] ml-[3px]" />
          AwardTool Guides
        </div>
      </MenuItem>
    </MenuList>
  );
};
export default ToolsMenu;
